import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AngularFire } from 'angularfire2';

@Component({
  selector: 'page-blocked',
  templateUrl: 'blocked.html'
})
export class Blocked {

  constructor(public navCtrl: NavController, public navParams: NavParams, public af: AngularFire) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad BlockedPage');
  }

  onLogout() {
    this.af.auth.logout();
  }

}



// WEBPACK FOOTER //
// ./src/pages/blocked/blocked.ts